<template>
  <div>
    <!-- 運行してるサービスの羅列 -->
    <TheDemandServiceIndexAndReservations
      v-if="isInServicePeriod"
      :demand-area="demandArea"
      :reservations="Reservations"
      :any-valid-reservation="anyValidReservation"
    />

    <TheDemandIndexOutOfService v-else />
  </div>
</template>

<script>
import { onMounted, ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TemplateDemandIndex",
  props: {
    demandArea: {
      type: Array,
      required: true,
    },
    Reservations: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    // 有効な予約の数を保持
    const anyValidReservation = ref(0);

    const isLogin = store.getters["common/isLogin"];

    const isInServicePeriod =
      process.env.VUE_APP_DEMAND_IN_SERVICE_PERIOD == "true";

    onMounted(async () => {
      anyValidReservation.value = props.Reservations.filter(function (r) {
        return (
          r.status == "ASSIGNED" ||
          r.status == "PICKING_UP" ||
          r.status == "BOARDING" ||
          r.status == "DRAFT" ||
          r.status == "SCHEDULED" ||
          r.status == "DRIVER_LAUNCHED" ||
          r.status == "USER_LAUNCHED"
        );
      }).length;
    });

    return {
      anyValidReservation,
      isLogin,
      isInServicePeriod,
    };
  },
};
</script>
